import { downloadCSV } from 'react-admin'
import jsonExport from 'jsonexport/dist'

const BOM = '\uFEFF';

export const getBommedExporter = (filename, csvOptions) => {
  return (data) => {
    //headers option이 존재할 경우 해당 컬럼만 출력
    if (csvOptions && csvOptions.headers) {
      data = JSON.parse(JSON.stringify(data, csvOptions.headers));
    }
    jsonExport(data, csvOptions, (err, csv) => {
      downloadCSV(`${BOM} ${csv}`, filename);
      if (err) {
        console.error(err);
      }
    });
  };
}